import { render, staticRenderFns } from "./DeliverySlotCard.vue?vue&type=template&id=8c5c2bd2&"
import script from "./DeliverySlotCard.vue?vue&type=script&lang=js&"
export * from "./DeliverySlotCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliverySlotCard.vue?vue&type=style&index=0&id=8c5c2bd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports